import styled, {css} from 'styled-components';

import {Select as BaseSelect} from '@edna/components';
import {Head as BaseHead, Option as BaseOption, Overlay} from '@edna/components/Select/style';
import {mixins} from '@edna/components/styles';

export const Select = styled(BaseSelect)`
  width: 200px;

  ${({theme}) => css`
    color: ${theme.palette.grey200};

    ${Overlay} {
      svg {
        ${mixins.wh('24px', '16px')}
      }
    }
  `}
`;

export const DarkSelect = styled(Select)`
  ${({theme, readOnly}) => css`
    width: 150px;
    color: ${theme.palette.grey200};

    ${Overlay}, ${BaseHead} {
      color: ${readOnly ? theme.palette.grey400 : theme.palette.grey200};
      background-color: ${theme.palette.black};
    }
  `}
`;

export const DarkOption = styled(BaseOption)`
  ${({theme: {palette, animation}, selected}) => css`
    background: ${selected ? palette.grey700 : palette.black};
    color: ${selected ? palette.white : palette.grey200};
    cursor: ${selected ? 'default' : 'pointer'};
    transition: color ${animation.duration}ms;

    &:hover {
      color: ${palette.white};
    }
  `}
`;
